import { Routes, Route } from 'react-router-dom'

import Home from './pages/Home'
import Pricing from './pages/Pricing'
import Pipeline from './pages/Pipeline'
import PropertyDashboard from './pages/PropertyDashboard'
import Arv from './pages/Arv'
import ListingDetails from './pages/ListingDetails'
import Login from './pages/Login'
import Signup from './pages/Signup'
import ProtectedRoute from './components/ProtectedRoute'

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/pipeline" element={
        <ProtectedRoute><Pipeline /></ProtectedRoute>
      } />
      <Route path="/property/:id" element={
        <ProtectedRoute><PropertyDashboard /></ProtectedRoute>
      } />
      <Route path="/property/:id/arv" element={
        <ProtectedRoute><Arv /></ProtectedRoute>
      } />
      <Route path="/property/:id/arv/listing/:listingIndex" element={
        <ProtectedRoute><ListingDetails /></ProtectedRoute>
      } />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
    </Routes>
  )
}

export default App
